export default __webpack_public_path__ + "static/media/img_03.1f995365.jpg";